import * as Yup from 'yup';

export const MAX_MESSAGE_LENGTH = 10000;

// Validity only gates the send button — error messages are never displayed
// (empty/short input disables send; the inputs' own maxLength blocks too-long).
export const CHAT_SCHEMA = Yup.object().shape({
  // trim() is a transform (non-strict mode): whitespace-only input validates as
  // empty, so it can't enable send and then get dropped by the composer's trim.
  message: Yup.string().trim().min(2).max(MAX_MESSAGE_LENGTH).required(),
});
